// @flow

// Selectors
import recommendationsFilteredByField$ from './selectors/recommendationsFilteredByField'
import tableState$ from './selectors/tableState'
import { crops$ } from 'fc-model-crops'
import { currentUserUnits$ } from 'hfty-users'
import { fertilizers$ } from 'hfty-fertilizers'

// DataTable Compose
import composeRecommendationDataTable from 'hfty-datatable-recommendations'

export default composeRecommendationDataTable({
  recommendations$: recommendationsFilteredByField$,
  tableState$,
  crops$,
  currentUserUnits$,
  fertilizers$,
})
